// Page « Liste d'invités mariage » (référencement). En français : elle vise « liste
// invités mariage », « modèle liste invités mariage », « liste invités mariage excel ».
// Le modèle Excel (public/modele-liste-invites-mariage.xlsx) est lisible par l'import
// de l'app : Prénom, Nom, Enfant, Téléphone, une colonne par événement (x ou oui).

import { FaqItem } from '../common/GuideLayout';

export const UPDATED = '2026-10-15';
export const READING_MINUTES = 7;
export const TEMPLATE_URL = '/modele-liste-invites-mariage.xlsx';

export const TOC = [
  { id: 'modele', label: 'Le modèle Excel gratuit' },
  { id: 'methode', label: 'Faire sa liste en 5 étapes' },
  { id: 'combien', label: 'Combien d’invités ?' },
  { id: 'cas', label: 'Familles, enfants, +1 : les cas délicats' },
  { id: 'en-ligne', label: 'Du tableur à la liste en ligne' },
  { id: 'faq', label: 'Questions fréquentes' },
];

// Colonnes du modèle : nom, rôle, et si l'import de l'app la reprend
export const COLUMNS: Array<[string, string, boolean]> = [
  ['Prénom, Nom', 'Une ligne par personne, enfants compris', true],
  ['Enfant', '« oui » pour un enfant : pas de menu adulte, compté à part', true],
  ['Téléphone', 'Pour les dernières informations ou une relance', true],
  ['Cérémonie, Vin d’honneur, Dîner, Brunch', 'Un « x » pour chaque moment où la personne est invitée', true],
  ['Groupe', 'Famille de la mariée, amis de fac, collègues… pour s’y retrouver', false],
  ['Notes', 'Témoin, végétarien, vient de loin, liste B…', false],
];

export const STEPS = [
  {
    title: 'Fixez un chiffre de départ',
    text: 'D’après la capacité du lieu et votre budget, avant d’écrire le moindre nom : c’est lui qui tranchera les hésitations.',
  },
  {
    title: 'Listez sans filtre',
    text: 'Chacun de votre côté, avec vos parents : famille, amis, collègues. Tout le monde, d’abord.',
  },
  {
    title: 'Rangez par cercles',
    text: 'Les incontournables, les très proches, puis ceux qu’il serait bien d’inviter. Les groupes aident à équilibrer les deux côtés.',
  },
  {
    title: 'Ajustez au chiffre',
    text: 'Si la liste déborde, retirez par cercle plutôt qu’au cas par cas : la règle est plus facile à expliquer.',
  },
  {
    title: 'Précisez qui vient à quoi',
    text: 'Cérémonie, vin d’honneur, dîner, brunch : tout le monde n’est pas invité partout. Notez-le dès maintenant.',
  },
];

export const CASES = [
  {
    title: 'Les « +1 »',
    text: 'Une règle simple et la même pour tous : par exemple, les couples installés et les témoins, mais pas les célibataires.',
  },
  {
    title: 'Les enfants',
    text: 'Tous, aucun, ou seulement ceux de la famille proche : décidez-le tôt et dites-le clairement sur l’invitation.',
  },
  {
    title: 'Les collègues',
    text: 'Tout le service ou personne : inviter à moitié crée plus de malaises qu’il n’en évite.',
  },
  {
    title: 'La liste B',
    text: 'Ceux que vous inviterez si des réponses négatives arrivent tôt. À garder discrète, et à prévenir sans tarder.',
  },
  {
    title: 'Les parents qui invitent',
    text: 'S’ils participent au budget, ils voudront inviter : fixez ensemble un nombre de places pour eux.',
  },
];

export const FAQ: FaqItem[] = [
  {
    q: 'Comment faire la liste des invités de son mariage ?',
    a: 'Fixez d’abord un nombre d’invités d’après le lieu et le budget, listez tout le monde sans filtre, rangez par cercles (incontournables, proches, à voir), puis ajustez au chiffre. Notez dès le départ qui est invité à quel moment.',
  },
  {
    q: 'Existe-t-il un modèle Excel gratuit de liste d’invités ?',
    a: 'Oui : téléchargez notre modèle gratuit, avec une colonne par moment de la journée. Il s’importe tel quel dans RSVP Please pour suivre ensuite les réponses en ligne.',
  },
  {
    q: 'Combien d’invités pour un mariage en moyenne ?',
    a: 'Autour de 90 invités en France, selon le Rapport sur le secteur nuptial 2026 de Mariages.net. Le bon nombre est celui que permettent votre lieu et votre budget.',
  },
  {
    q: 'Faut-il compter les enfants dans la liste d’invités ?',
    a: 'Oui, une ligne par enfant, en le signalant comme enfant : il compte pour les places et le plan de table, mais pas pour le menu adulte.',
  },
  {
    q: 'Faut-il inviter les conjoints de ses amis ?',
    a: 'Pour les couples installés, c’est l’usage. Pour les autres, fixez une règle et appliquez-la à tous : c’est ce qui évite les vexations.',
  },
  {
    q: 'Comment suivre les réponses de la liste d’invités ?',
    a: 'Dans un tableur, il faut tout recopier à la main. En important votre liste dans RSVP Please, chaque invité répond en ligne et sa réponse s’inscrit dans la liste, avec des compteurs par événement.',
  },
];
